import { useCallback, useState } from 'react';
import { SimpleForm } from 'react-admin';
import { isPlainObject } from 'lodash';
import ClearIcon from '@mui/icons-material/Clear';
import Button from '@mui/material/Button';
import GooglePlacesAutocomplete from '@/components/utils/GooglePlacesAutocomplete';
import { GooglePlacesPayload } from '@/components/utils/GooglePlacesAutocomplete/types';
import { CreateStyled } from '@/styles/overrides';
import { FCRAWorker } from '@/types/turn-api';
import FormContent from './FormContent';
import { HeaderContainer } from './styled';
import { AddAddressFormProps } from './types';
import { transformAddressDetails } from './utils';

const AddAddressForm = ({ onClose, ...props }: AddAddressFormProps) => {
  const [addressDefaults, setAddressDefaults] = useState<FCRAWorker.Address>(null);

  const handleGooglePlaceSelect = useCallback((data: GooglePlacesPayload) => {
    if (!isPlainObject(data)) return;

    const transformed = transformAddressDetails(data);
    setAddressDefaults(transformed);
  }, []);

  return (
    <>
      <HeaderContainer>
        <Button variant="text" aria-label="Add" onClick={onClose}>
          <ClearIcon />
        </Button>
        <GooglePlacesAutocomplete onPlaceSelect={handleGooglePlaceSelect} />
      </HeaderContainer>

      <CreateStyled title="Add Address" {...props}>
        <SimpleForm
          id="candidate-addresses-form"
          defaultValues={addressDefaults}
          key={JSON.stringify(addressDefaults)} // React Admin only applies defaultValues on mount, changing the key forces the form to remount and apply new defaults.
          mode="onChange"
          reValidateMode="onChange"
          toolbar={false}
        >
          <FormContent onClose={onClose} />
        </SimpleForm>
      </CreateStyled>
    </>
  );
};

export default AddAddressForm;
